"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _AllocateCreditsModal = _interopRequireDefault(require("../components/AllocateCreditsModal"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function AllocateCreditsModalContainer(_ref) {
  var organisationId = _ref.organisationId,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose,
      onSave = _ref.onSave,
      isSetRecurringMode = _ref.isSetRecurringMode,
      orgBalance = _ref.orgBalance,
      creditType = _ref.creditType,
      onCreditTypeChange = _ref.onCreditTypeChange,
      teams = _ref.teams,
      isUnlimited = _ref.isUnlimited,
      onGoToSetRecurring = _ref.onGoToSetRecurring,
      updatedTeams = _ref.updatedTeams,
      onCreditsAllocationChange = _ref.onCreditsAllocationChange,
      orgRecurringBalance = _ref.orgRecurringBalance,
      onDeleteCreditRule = _ref.onDeleteCreditRule;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      updateTeamCredits: (0, _api.updateTeamCreditsMutation)(organisationId),
      deleteCreditRule: (0, _api.deleteCreditRuleMutation)()
    }
  }, function (_ref2) {
    var deleteCreditRule = _ref2.deleteCreditRule,
        updateTeamCredits = _ref2.updateTeamCredits;
    return _react.default.createElement(_AllocateCreditsModal.default, {
      isVisible: isVisible,
      onClose: onClose,
      onSave: onSave,
      isSetRecurringMode: isSetRecurringMode,
      orgBalance: orgBalance,
      creditType: creditType,
      onCreditTypeChange: onCreditTypeChange,
      teams: teams,
      isUnlimited: isUnlimited,
      onGoToSetRecurring: onGoToSetRecurring,
      updatedTeams: updatedTeams,
      deleteCreditRule: deleteCreditRule,
      onCreditsAllocationChange: onCreditsAllocationChange,
      updateTeamCredits: updateTeamCredits,
      onDeleteCreditRule: onDeleteCreditRule,
      orgRecurringBalance: orgRecurringBalance
    });
  });
}

var _default = AllocateCreditsModalContainer;
exports.default = _default;